module.exports = __webpack_public_path__ + "static/media/cross-icon.fbadc92b.svg";